import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing a view for advertising table.
 * @extends JetView
 */
export default class tableAdvertisingView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Define the date format for displaying dates
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Get the current user parameter from the request
        const cur_user = this.getParam('user', true);
        return {
            // Define the main view as a datatable
            view: 'datatable',
            // Apply CSS classes for styling
            css: 'webix_header_border webix_data_border',
            // Set a unique ID for the datatable
            id: 'datatable3',
            // Enable row selection
            select: true,
            // Set the minimum height of the datatable
            minHeight: 300,
            // Define the columns of the datatable
            columns: [
                {
                    // Column for rating with an icon for editing
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    // Tooltip text for the column
                    tooltip: 'Editar',
                    // Hide the column based on user permissions
                    hidden: !devConfig.getPermAction('permAdvertising', 'Edit'),
                    // CSS class for permission indication
                    css: 'prm-permAdvertising',
                    // Template function to render the edit icon
                    template: function (obj) {
                        return "<span class='webix_icon wxi-close edit'></span>";
                    },
                },
                // Column for ID with sorting enabled
                { id: 'Id', header: 'ID', width: 100, sort: 'int' },
                // Column for Name with localization support
                { id: 'Name', header: _('Nombre'), width: 300, sort: 'int' },
                // Column for Route with localization support
                { id: 'Route', header: _('Ruta'), width: 350, sort: 'int' },
                {
                    // Column for activation status with a combo editor
                    id: 'IsActivate',
                    header: _('Estado'),
                    editor: 'combo',
                    // Options for the combo editor
                    options: [
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    width: 200,
                    sort: 'int',
                },
                // Column for Order with sorting enabled
                { id: 'Order', header: 'Orden', width: 270, sort: 'int' },
            ],
            // Event handler for click events on the edit icon
            onClick: {
                edit: function (euv, id) {
                    // Show the advertising edit window
                    $$('editwinAdvertising').show();
                },
            },
            // Enable tooltips for the datatable
            tooltip: true,
            // Enable mathematical operations in the datatable
            math: true,
            // Set the data fetching configuration
            loadahead: devConfig.getDefaultDataFetch(),
            // Set the pager ID for pagination
            pager: 'pagerA',
            // Define the URL for fetching data, including the current user ID
            url: devConfig.geturlApi() + 'es/BetShop/GetAdvertising?FromId=' + cur_user + '&',
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Get the URL for the grid data
        var url = grid.data.url;
        // Get the current user parameter
        const cur_user = this.getParam('user', true);
        // Attach an event to reload grid data after sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + '&sort[' + by + ']=' + dir);
        });
        // Attach an event to handle item clicks in the grid
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id);
            // Trigger an event with the selected item's ID
            this.$scope.app.callEvent('user:id', [item.Id]);
        });
        // Listen for the event to show the add advertising popup
        this.on(this.app, 'addAdvertising:button', (filter) => {
            popupAdd.show();
        });
        // Define the popup for adding advertising
        var popupAdd = webix.ui({
            view: 'window',
            id: 'addwin',
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Añadir Publicidad') },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        // Close the popup when the icon is clicked
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center',
            modal: true,
            width: 5000,
            body: {
                view: 'form',
                id: 'saveformAdv',
                elements: [
                    {
                        view: 'text',
                        name: 'Name',
                        label: _('Nombre'),
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                    },
                    {
                        view: 'text',
                        name: 'Route',
                        label: _('Ruta'),
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                    },
                    {
                        view: 'combo',
                        label: _('Estado'),
                        name: 'IsActivate',
                        labelWidth: 150,
                        width: 300,
                        options: [
                            { id: 'A', value: _('Activado') },
                            { id: 'I', value: _('Inactivado') },
                        ],
                    },
                    {
                        view: 'text',
                        value: '0',
                        name: 'Order',
                        label: _('Orden'),
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                        type: 'number',
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'),
                                // Close the popup when the cancel button is clicked
                                click: function () {
                                    this.getTopParentView().hide();
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'),
                                // Handle the save action for the form
                                click: function ($e) {
                                    var values = $$('saveformAdv').getValues();
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/BetShop/SaveAdvertising',
                                            '{"FromId":"' +
                                                cur_user +
                                                '","Name":"' +
                                                values.Name +
                                                '","Route":"' +
                                                values.Route +
                                                '","IsActivate":"' +
                                                values.IsActivate +
                                                '","Order":"' +
                                                values.Order +
                                                '"}',
                                            {
                                                // Handle error response
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! '));
                                                },
                                                // Handle success response
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Publicidad Añadida'));
                                                    grid.clearAll();
                                                    grid.load(url);
                                                },
                                            },
                                        );
                                    // Clear the form after submission
                                    $$('saveformAdv').clear();
                                    this.getTopParentView().hide();
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Define the popup for editing advertising
        var popupEdit = webix.ui({
            view: 'window',
            id: 'editwinAdvertising',
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Editar Publicidad') },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        // Close the popup when the icon is clicked
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center',
            modal: true,
            width: 5000,
            body: {
                view: 'form',
                id: 'editformAdv',
                elements: [
                    {
                        view: 'text',
                        name: 'Id',
                        label: 'ID',
                        labelWidth: 150,
                        width: 300,
                        disabled: true, // ID field is read-only
                    },
                    {
                        view: 'text',
                        name: 'Name',
                        label: _('Nombre'),
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                    },
                    {
                        view: 'text',
                        name: 'Route',
                        label: _('Ruta'),
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                    },
                    {
                        view: 'combo',
                        label: _('Estado'),
                        name: 'IsActivate',
                        labelWidth: 150,
                        width: 300,
                        options: [
                            { id: 'A', value: _('Activado') },
                            { id: 'I', value: _('Inactivado') },
                        ],
                    },
                    {
                        view: 'text',
                        name: 'Order',
                        label: _('Orden'),
                        labelWidth: 150,
                        width: 300,
                        sort: 'int',
                        type: 'number',
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'),
                                // Close the popup when the cancel button is clicked
                                click: function () {
                                    this.getTopParentView().hide();
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'),
                                // Handle the save action for the edit form
                                click: function ($e) {
                                    var values = $$('editformAdv').getValues();
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json',
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'es/BetShop/SaveAdvertising',
                                            '{"FromId":"' +
                                                cur_user +
                                                '","Id":"' +
                                                values.Id +
                                                '","Name":"' +
                                                values.Name +
                                                '","Route":"' +
                                                values.Route +
                                                '","IsActivate":"' +
                                                values.IsActivate +
                                                '","Order":"' +
                                                values.Order +
                                                '"}',
                                            {
                                                // Handle error response
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Error! '));
                                                },
                                                // Handle success response
                                                success: function (text, data, XmlHttpRequest) {
                                                    webix.message(_('Publicidad Actualizada'));
                                                    grid.clearAll();
                                                    grid.load(url);
                                                },
                                            },
                                        );
                                    // Clear the form after submission
                                    $$('saveformAdv').clear();
                                    this.getTopParentView().hide();
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Listen for player selection to load corresponding grid data
        this.on(this.app, 'player:select', (Id) => {
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&FromId=' + Id);
        });
        // Attach an event to handle double-click on grid items for editing
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            if (devConfig.getPermAction('permAdvertising', 'Edit')) {
                popupEdit.show();
            }
        });
        // Bind the edit form to the data table
        $$('editformAdv').bind($$('datatable3')); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
